import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormRenderConfig} from '../form-schema-renderer.component';
import {JSONSchema7} from 'json-schema';
import {SessionItemData} from '../../../workflow/services/session-item-data';
import {Resolver} from '@stoplight/json-ref-resolver';

@Component({
	selector: 'app-card-style-array-renderer',
	templateUrl: './card-style-renderer-type-array.component.html',
	styleUrls: ['./card-style-renderer-type-array.component.scss']
})
export class CardStyleRendererArrayTypeComponent implements OnInit, OnChanges {
	@Input() formConfig: FormRenderConfig;
	@Input() schemaKey: string;
	@Input() schema: JSONSchema7;
	@Input() data: SessionItemData;
	@Input() property: string[];
	@Input() required: boolean;
	@Output() valid: EventEmitter<boolean> = new EventEmitter();

	resolvedSchema: JSONSchema7;
	items: Array<{ label: string; value: string }> = [];

	constructor() {
	}

	ngOnInit(): void {
		this.valid.emit(!this.required);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.schema && this.schema) {
			const resolver = new Resolver();
			resolver.resolve(this.schema).then(resolved => {
				this.resolvedSchema = resolved.result;
				if (this.resolvedSchema && this.resolvedSchema.items) {
					const itemArray = this.resolvedSchema.items as string[];
					itemArray.forEach( item => {
						this.items.push({ label: item, value: item });
					});
				}
			}).catch(console.error);
		}
	}

	get key(): string {
		return this.property.join('.');
	}

	get value(): unknown {
		return this.data.getProperty(this.property);
	}

	set value(value: unknown) {
		this.data.setProperty(this.property, value);
	}

	setValid(input: unknown): void {
		this.valid.emit(!!input || !this.required);
	}
}
